










































import { SignUpFormParts } from '@spa/components/pages/auth/signup/shared/form-parts/form-parts'
import _ from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class InputPassword extends Vue {
  @Prop({ required: true })
  readonly formParts: SignUpFormParts

  @Prop({ required: true })
  readonly step: number

  password: string = ''

  async submit() {
    const validated = await this.validateForm()

    if (!validated) {
      return
    }
    this.$emit('input-password', this.password)
  }

  get validatorErrors(): Array<{ field: string }> {
    return this.$validator.errors.items
  }

  get hasPasswordValidationError(): boolean {
    return _.some(this.validatorErrors, e => e.field === 'password')
  }

  get showPasswordDescription(): boolean {
    if (this.password === '') {
      return true
    }

    return !this.hasPasswordValidationError
  }

  private async validateForm(): Promise<boolean> {
    if (this.password.length === 0) {
      return false
    }

    this.$validator.validateAll()

    return this.$validator.validateAll()
  }
}
